import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { yesNoOptions } from "../../../shared/constants/components";
import { UserInfo } from "../../../shared/types/user-info";
import { MaintenanceProvider } from "./maintenance-provider.types";

//#region Search Filter Options

export const getMaintenanceProviderSearchFilterOptions = (
  user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
  },
): SearchFilterOption<MaintenanceProvider>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      { value: "name", label: "Name", disabled: false },
      {
        value: "isChannelWorks",
        label: "Is Staff Managed",
        disabled: false,
        inputType: "dropdown",
        options: [...yesNoOptions],
        condition: "$eq",
      },
      {
        value: "enabled",
        label: "Enabled",
        disabled: false,
        inputType: "dropdown",
        options: [...yesNoOptions],
        condition: "$eq",
      },
    ] as SearchFilterOption<MaintenanceProvider>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion
